import { FooterPadrao } from "./styled";

//PROPS
interface Props {
    children?: React.ReactNode;
}

const Footer: React.FC<Props> = ({ children }) => {
    return (
        <FooterPadrao>
            {children}
        </FooterPadrao>
    )
};

export default Footer;